module.exports = __webpack_public_path__ + "0b71b4d44a27b856d1b91f1252da5fa1.jpg";